export default {
    titles: {
        default: '',
        networkCoverage: 'Network coverage map',
        internetSpeeds: 'Internet speeds map',
        usageTrends: 'Usage trends map',
    },
    buttons: {
        networkCoverage: 'Network coverage',
        internetSpeeds: 'Internet speeds',
        usageTrends: 'Usage trends',
    },
    inputs: {
        accessType: {
            title: 'Access type',
            wifi: 'wifi',
            cellular: 'cellular',
            both: 'both'
        },
        technology: {
            title: 'Technology',
            '2g': '2G',
            '3g': '3G',
            '4g': '4G',
            '5g': '5G'
        },
        isp: {
            title: 'ISP',
        },
        administrativeLevels: {
            title: 'Divisions'
        },
        monthPicker: {
            title: 'Period',
            months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
        },
        towers: {
            title: 'Show Towers'
        }
    }
}